import {graphql} from 'gatsby'
import React from 'react'

import type {PanelGridSliceFragment} from '@/graphql-types'
import {PanelGrid} from '@/sections/panel-grid'
import type {PanelGridProps} from '@/sections/panel-grid'

type Props = {
    slice: PanelGridSliceFragment
}

type LabelColor = PanelGridProps['items'][0]['labelColor']

export const PanelGridSlice = ({slice}: Props) => {
    const content = slice.primary

    return (
        <PanelGrid
            title={content.title}
            excerpt={content.excerpt}
            items={slice.items.map((item) => ({
                labelColor: item.label_color as LabelColor,
                labelText: item.label_text,
                heading: item.heading,
                excerpt: item.excerpt,
                ctaText: item.cta_text,
                ctaLink: item.cta_link,
            }))}
        />
    )
}

export const sliderCardsSliceFragment = graphql`
    fragment PanelGridSlice on PrismicSlicePageDataBodyPanelGrid {
        __typename
        primary {
            title
            excerpt
        }
        items {
            label_color
            label_text
            heading
            excerpt
            cta_text
            cta_link {
                ...PrismicLink
            }
        }
    }
`
